<script setup lang="ts">

import {useCurrentWorkspaceUser, useEnvironment} from "~/stores/spaces";
import {useUiNotifications} from "~/stores/ui-notifications";
import {removePlanFromEnvironment} from "~/calls/subscription";

const router = useRouter();
const {workspaceId, environmentId, environment} = useEnvironment()
const {plan} = useSubscriptionForEnvironment()

const {showUiNotification} = useUiNotifications();
const {isAdmin, isOwner, workspaceOwnerEmail} = useCurrentWorkspaceUser()

const loading = ref(false)


const updatePlan = () => {
  loading.value = true
  downgradePlan()
}

const downgradePlan = () => {

  removePlanFromEnvironment(workspaceId.value, environmentId.value, plan.value?.type!!).then((r) => {
    if (!r.success) return
    router.push({
      path: `/workspace/${workspaceId.value}/env/${environmentId.value}/subscription`,
      query: {action: 'downgrade'}
    })
  }).finally(() => {
    loading.value = false
  })
}
</script>
<template>
  <p class="mt-4">
    Downgrading to the Developer Plan instead of the {{ environment.featureSet.name }} Plan will limit your available
    features.
  </p>
  <p class="mt-4">
    Before proceeding with the downgrade, please make sure that you only have one node in the cluster. Follow the
    instructions to deregister a node in your Cluster Overview.
  </p>
  <v-alert v-if="!isOwner" type="info" class="my-4">
    Only the owner of the workspace, {{ workspaceOwnerEmail }} can change the subscription.
  </v-alert>
  <p class="mt-4 mb-2 text-end">
    <v-btn color="secondary" :loading="loading" @click="updatePlan" :disabled="!isOwner">I understand, cancel my
      Subscription
    </v-btn>
  </p>

</template>
